module.exports = __webpack_public_path__ + "img/shape2.27038015.svg";